import { CHARADE_GREY, MANATEE_GREY } from "../../../constants/colors";

const inactiveColor = MANATEE_GREY;
const activeColor = CHARADE_GREY;

export const fallbackValues = {
  inactiveColor,
  activeColor
};
